import CmsButtonComponent from './cms-button.component';
import { cookiesMadeSimpleProperties } from "../properties/cookies-made-simple.property";
import { Status } from '../enums/status.enum';
import { Category } from '../enums/category.enum';
import CookieComponent from './cookie.component';
import { translate } from '../services/i18n.service';
import cookiesService from '../services/cookies.service';
var CookieConsentComponent = /** @class */ (function () {
    function CookieConsentComponent() {
        var _this = this;
        this.modalToggleClass = 'cookies-made-simple-active';
        this.unmount = function () {
            _this.unmountListeners();
            _this.unmountButtons();
        };
        this.saveCookiePreferences = function () {
            _this.optionalCookies.forEach(function (cookieData) {
                var _a;
                if ((_a = cookieData.component) === null || _a === void 0 ? void 0 : _a.getState()) {
                    cookieData.status = Status.ACCEPTED;
                }
                else {
                    cookieData.status = Status.REFUSED;
                }
                ;
            });
            cookiesService.applyAndSaveCookiePreferences(_this.optionalCookies);
            _this.toggleModal();
        };
        this.acceptAllCookies = function () {
            _this.optionalCookies.forEach(function (cookieData) {
                var _a;
                cookieData.status = Status.ACCEPTED;
                (_a = cookieData.component) === null || _a === void 0 ? void 0 : _a.setState(true);
            });
            _this.saveCookiePreferences();
        };
        this.toggleModal = function () {
            document.body.classList.toggle(_this.modalToggleClass);
        };
        this.unmountListeners = function () {
            document.querySelectorAll(".cookies-made-simple-toggle").forEach(function (element) {
                element.removeEventListener('click', _this.toggleModal);
            });
        };
        this.initializeListeners = function () {
            document.querySelectorAll(".cookies-made-simple-toggle").forEach(function (element) {
                element.addEventListener('click', _this.toggleModal);
            });
        };
        this.unmountButtons = function () {
            var _a, _b;
            (_a = _this.acceptAllBtn) === null || _a === void 0 ? void 0 : _a.unmount();
            (_b = _this.savePreferencesBtn) === null || _b === void 0 ? void 0 : _b.unmount();
        };
        this.initializeButtons = function () {
            _this.acceptAllBtn = new CmsButtonComponent('cmsFooterAcceptAll', _this.acceptAllCookies);
            _this.savePreferencesBtn = new CmsButtonComponent('cmsFooterSavePreferences', _this.saveCookiePreferences);
        };
        this.initializeState = function () {
            var showCookieApprovalWindow = false;
            if (_this.optionalCookies) {
                showCookieApprovalWindow = _this.optionalCookies.findIndex(function (cookieData) { return cookieData.status === Status.PENDING; }) >= 0;
            }
            cookiesService.applyCookiePreferences(_this.optionalCookies);
            if (showCookieApprovalWindow) {
                _this.toggleModal();
            }
        };
        this.render = function () {
            if (cookiesMadeSimpleProperties.showMandatoryCookies) {
                _this.renderMandatoryCookies();
            }
            if (cookiesMadeSimpleProperties.areCookiesGroupedByCategory) {
                _this.renderOptionalCookiesByCategory();
            }
            else {
                _this.renderOptionalCookies();
            }
        };
        this.renderMandatoryCookies = function () {
            var cookiesContainer = document.getElementById('cookiesMadeSimpleMandatories');
            if (cookiesContainer) {
                cookiesContainer.innerHTML = '';
                /*
                mandatoryCookies.forEach(cookieData => {
                  const cookieComponent = new CookieComponent(cookieData, cookiesMadeSimpleProperties);
                  cookieData.component = cookieComponent;
                  cookiesContainer.appendChild(cookieComponent.render());
                });
                */
            }
            else {
                console.error("CMS: Unexpected mandatory cookies rendering failed due to missing DOM element.");
            }
        };
        this.renderOptionalCookies = function () {
            var cookiesContainer = document.getElementById('cookiesMadeSimpleOptionals');
            if (cookiesContainer) {
                cookiesContainer.innerHTML = '';
                _this.optionalCookies.forEach(function (cookieData) {
                    var cookieComponent = new CookieComponent(cookieData);
                    cookieData.component = cookieComponent;
                    cookiesContainer.appendChild(cookieComponent.render());
                });
            }
            else {
                console.error("CMS: Unexpected optional cookies rendering failed due to missing DOM element.");
            }
        };
        this.renderOptionalCookiesByCategory = function () {
            var functionalElement = document.getElementById('cookiesMadeSimpleFunctionalOptionalsCookies');
            var performanceElement = document.getElementById('cookiesMadeSimplePerformanceOptionalsCookies');
            var targetingElement = document.getElementById('cookiesMadeSimpleTargetingOptionalsCookies');
            if (functionalElement && performanceElement && targetingElement) {
                functionalElement.innerHTML = "";
                performanceElement.innerHTML = "";
                targetingElement.innerHTML = "";
                _this.optionalCookies.forEach(function (cookieData) {
                    var cookieComponent = new CookieComponent(cookieData);
                    cookieData.component = cookieComponent;
                    switch (cookieData.category) {
                        case Category.FUNCTIONAL:
                            functionalElement.appendChild(cookieComponent.render());
                            break;
                        case Category.PERFORMANCE:
                            performanceElement.appendChild(cookieComponent.render());
                            break;
                        case Category.TARGETING:
                            targetingElement.appendChild(cookieComponent.render());
                            break;
                        default:
                            console.warn("CMS: Unexpected cookie category [" + cookieData.category + "] couldn't be generated.");
                    }
                });
            }
            else {
                console.error("CMS: Unexpected optional cookies rendering failed due to missing DOM element.");
            }
        };
        var perfStart = window.performance.now();
        this.optionalCookies = cookiesService.getOptionalCookies();
        translate();
        this.initializeState();
        this.initializeListeners();
        this.initializeButtons();
        this.render();
        console.log("CMS: initialization took: ".concat(Math.ceil(window.performance.now() - perfStart), "ms"));
    }
    return CookieConsentComponent;
}());
export default CookieConsentComponent;
